const style = {
  grid: {
    justifyContent: 'space-between',
    spacing: 3,
    sx: {
      alignItems: 'center',
      display: 'flex',
      overflow: 'hidden',
    },
  },
  box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  titleText: {
    variant: 'h4',
    sx: {
      pl: 2,
    },
  },
  titleCompanyName: {
    variant: 'h4',
    sx: {
      pl: 2,
      opacity: 0.6,
    },
  },
  subTitle: {
    box: {
      sx: {
        display: 'flex',
        alignItems: 'center',
        pt: 1,
      },
    },
    locationBox: {
      sx: {
        display: 'flex',
        alignItems: 'center',
        pl: 2,
      },
      locationText: {
        variant: 'body2',
        sx: {
          pl: 1,
        },
      },
    },
    dateBox: {
      sx: {
        display: 'flex',
        alignItems: 'center',
        pl: 2,
      },
      text: {
        variant: 'body2',
        sx: {
          pl: 1,
        },
      },
    },
    internalUserBox: {
      justifyContent: 'flex-end',
      sx: {
        display: 'flex',
        alignItems: 'center',
        pt: 1,
        pr: 1,
      },
      text: {
        variant: 'body2',
        sx: {
          pl: 1,
        },
      },
    },
  },
  action: {
    grid: {
      sx: {
        '& > *': {
          m: 1,
        },
      },
    },
    history: {
      sx: {
        textAlign: 'center',
        width: 25,
        p: 1,
        backgroundColor: 'none',
      },
    },
    create: {
      icon: {
        fontSize: 'small',
      },
      variant: 'contained',
      sx: {
        m: 1,
        backgroundColor: 'secondary.main',
      },
    },
    edit: {
      sx: {
        m: 1,
      },
      icon: {
        fontSize: 'small',
      },
      variant: 'outlined',
    },
  },
} as const;

export default style;
